// extracted by mini-css-extract-plugin
module.exports = {"taxCredit":"TaxCredit_taxCredit__bVRYL"};